import React, { Component } from "react";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { InputLabel } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import { MenuItem } from "@material-ui/core";
import { FormControl } from "@material-ui/core";
import Select from "@material-ui/core/Select";
import { withStyles } from "@material-ui/styles";
import ImageCapture from "../../organisms/ImageCapture";

import IDcardFront from "../../../img/id-card-front.png";
import IDcardBack from "../../../img/id-card-back.png";
import IDcardSelfi from "../../../img/id-card-selfi.png";
import PassportFront from "../../../img/passport-front.png";
import PassportSelfi from "../../../img/passport-selfi.png";

const styles = theme => ({
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "100%",
    maxWidth: "350px"
  }
});

class IdentityDocCapture extends Component {
  render() {
    /*
    spezielle Fixes um im Dialog Upload und Kamera Option anzuzeigen
  */
    const { classes } = this.props;

    return (
      <React.Fragment>
        <Typography variant="h5" style={{ marginTop: "2em" }} gutterBottom>
          Uploading Identity Document and Close-up Photo
        </Typography>
        <Grid container spacing={10}>
          <Grid item xs={12} sm={6}>
            <FormControl className={classes.textField}>
              <InputLabel htmlFor="document-type">Document type</InputLabel>
              <Select
                className={classes.textField}
                value={this.props.values.document_type}
                required
                error={typeof this.props.errors.document_type === "string"}
                onChange={this.props.handleChange}
                inputProps={{
                  name: "document_type",
                  id: "document-type"
                }}
              >
                {/* <MenuItem value="">
                  <em>None</em>
                </MenuItem> */}
                <MenuItem value={"Passport"}>Passport</MenuItem>
                {/* <MenuItem value={"ID Card"}>ID Card</MenuItem> */}
              </Select>
            </FormControl>
            <Typography>
              <small style={{ color: "grey", paddingLeft: "17px" }}>
                Drivers License is not a valid form of ID
              </small>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              type="text"
              name="document_id"
              label="Document ID"
              className={classes.textField}
              onChange={this.props.handleChange}
              value={this.props.values.document_id}
              required
              onBlur={this.props.handleBlur}
              error={typeof this.props.errors.document_id === "string"}
              helperText={
                this.props.errors.document_id && this.props.touched.document_id
                  ? this.props.errors.document_id
                  : ""
              }
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <ImageCapture
              description={`${
                this.props.values.document_type === "Passport"
                  ? "The page of your Passport which holds your biographical data (name, date of birth, passport number, expiration date, photo,..)"
                  : "Front side photo of your ID Card"
              }`}
              button_text="Upload"
              variable_name="frontside"
              image={this.props.values.frontside}
              image_placeholder={
                this.props.values.document_type === "Passport"
                  ? PassportFront
                  : IDcardFront
              }
              setFieldValue={this.props.setFieldValue}
              error={this.props.errors.frontside}
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={4}
            style={
              this.props.values.document_type === "Passport"
                ? { display: "none" }
                : null
            }
          >
            <ImageCapture
              description={`Back side photo of your ${
                this.props.values.document_type === "Passport"
                  ? "Passport"
                  : "ID Card"
              }`}
              button_text="Upload"
              variable_name="backside"
              image={this.props.values.backside}
              image_placeholder={IDcardBack}
              setFieldValue={this.props.setFieldValue}
              error={this.props.errors.backside}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <ImageCapture
              description="Close-up photo of you holding the document"
              button_text="Upload"
              variable_name="selfi"
              image={this.props.values.selfi}
              image_placeholder={
                this.props.values.document_type === "Passport"
                  ? PassportSelfi
                  : IDcardSelfi
              }
              setFieldValue={this.props.setFieldValue}
              error={this.props.errors.selfi}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

IdentityDocCapture.propTypes = {
  values: PropTypes.object,
  errors: PropTypes.object,
  touched: PropTypes.object,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  setFieldValue: PropTypes.func
};
export default withStyles(styles)(IdentityDocCapture);
